class ErrorWithExtraInfo extends Error {
  private info: any;
  constructor(msg: string, info: any) {
    super(msg);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ErrorWithExtraInfo);
    }
    this.info = info;
  }
}

export default ErrorWithExtraInfo;
